export const URL = "https://jsonplaceholder.typicode.com/"
//export const DOMAIN_URL = "http://198.38.81.231:8080/api"
//export const AUTH_URL = "http://198.38.81.231:8080/api/auth"

// export const DOMAIN_URL = "https://workmates4u.com/api"
// export const AUTH_URL = "https://workmates4u.com/api/auth"

// export const DOMAIN_URL = "https://demo.workmates4u.com/api"
// export const AUTH_URL = "https://demo.workmates4u.com/api/auth"

// export const DOMAIN_URL = "http://localhost:8080/api"
// export const AUTH_URL = "http://localhost:8080/api/auth"

// export const DOMAIN_URL = "http://200.141.6.134/api"
// export const AUTH_URL = "http://200.141.6.134/api/auth"

export const DOMAIN_URL = "https://apps.swarcklabs.com/workmate/api"
export const AUTH_URL = "https://apps.swarcklabs.com/workmate/api/auth"